export default `
<div class="dashboard-card-list">
  <div role="list" aria-label="Invitations" ng-if="$ctrl.invitations.length > 0">
    <dashboard-activity-project-list-item role="listitem" project="project" item-type="invitation" tester-app-url="{{$ctrl.profile_url}}" ng-repeat="project in $ctrl.invitations"></dashboard-activity-project-list-item>
  </div>
  <dashboard-activity-project-list-footer item-count="{{$ctrl.invitationsCount}}" item-type="invitation" tester-app-url="{{$ctrl.profile_url}}" ng-if="$ctrl.invitationsCount > 5"></dashboard-activity-project-list-footer>
  <dashboard-activity-project-empty-list-notification have-no="current invitations" ng-if="$ctrl.invitationsCount === 0"></dashboard-activity-project-empty-list-notification>
</div>
`;
